import { IFavoriteItem } from '../actions/favorites';

const FAVORITES_STORAGE_KEY = 'cm_favourites_tabs';

export const favoritesStorage = {
  // Load favorites from localStorage
  load(): { [moduleId: string]: IFavoriteItem } {
    try {
      const stored = localStorage.getItem(FAVORITES_STORAGE_KEY);
      if (!stored) {
        return {};
      }

      const parsed = JSON.parse(stored);

      // Validate the structure
      if (typeof parsed !== 'object' || Array.isArray(parsed)) {
        console.warn('Invalid favorites data in localStorage');
        return {};
      }

      // Filter out any invalid entries
      const validated: { [moduleId: string]: IFavoriteItem } = {};

      Object.entries(parsed).forEach(([moduleId, item]) => {
        // Type guard to check if item is a valid favorite
        if (item && typeof item === 'object' && !Array.isArray(item)) {
          const maybeItem = item as any;
          if (
            maybeItem.module &&
            typeof maybeItem.language === 'string' &&
            typeof maybeItem.courseName === 'string' &&
            typeof maybeItem.moduleId === 'string'
          ) {
            validated[moduleId] = maybeItem as IFavoriteItem;
          }
        }
      });

      return validated;
    } catch (error) {
      console.error('Error loading favorites from localStorage:', error);
      return {};
    }
  },

  // Save favorites to localStorage
  save(favorites: { [moduleId: string]: IFavoriteItem }): void {
    try {
      // Check storage quota before saving
      const dataStr = JSON.stringify(favorites);

      // Rough estimate: 1 character = 2 bytes in localStorage
      const estimatedSize = dataStr.length * 2;
      const maxSize = 5 * 1024 * 1024; // 5MB limit

      if (estimatedSize > maxSize) {
        console.warn('Favorites data exceeds localStorage limit');
        // Could implement cleanup of old favorites here
        return;
      }

      localStorage.setItem(FAVORITES_STORAGE_KEY, dataStr);
    } catch (error) {
      console.error('Error saving favorites to localStorage:', error);

      // Handle quota exceeded error
      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        console.error('localStorage quota exceeded');
        // Could implement cleanup strategy here
      }
    }
  },

  // Clear all favorites from localStorage
  clear(): void {
    try {
      localStorage.removeItem(FAVORITES_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing favorites from localStorage:', error);
    }
  },
};
